import { Outlet, useParams } from "react-router-dom";
import { Card, CardHeader } from "reactstrap";

import { NavTabs, TabContent } from "components/NavTabs";
import { creatorTabOptions } from "features/creators/constants/tabOptions";

export function CreatorAssignmentsPageSection() {
  const { assignmentsTab, creator_id } = useParams();
  return (
    <div className="creator-assignments-page-section d-flex flex-fill position-relative">
      <Card className="border-0 rounded-0 flex-fill" outline body={false}>
        <CardHeader>
          <NavTabs tabs={creatorTabOptions} />
        </CardHeader>
        <TabContent
          className="p-2"
          activeTabId={assignmentsTab}
          tabs={creatorTabOptions}
          creator_id={creator_id}
        />
      </Card>
      <Outlet />
    </div>
  );
}
